import React, { useCallback } from 'react';
import { Add } from '@mui/icons-material';
import { IconButton } from '@mui/material';
import { ACL_PERMISSIONS } from '../../../../../../services/config/accessControl';
import { FadingTooltip } from '../../../../../../ui';
import { useUploadButton } from './UploadButtonHooks';

export const UploadButton = () => {
  const { dataset, fileTypeFilter, tooltipText, uploadFiles } = useUploadButton();

  const openUploadDialog = useCallback(
    async (event) => {
      await uploadFiles(event);
      // Fix Chrome/Edge "cache" behaviour.
      // HTML input is not triggered when the same file is selected twice
      event.target.value = null;
    },
    [uploadFiles]
  );

  const userPermissionsOnDataset = dataset?.security?.currentUserPermissions ?? [];
  const canUserUploadFiles = userPermissionsOnDataset.includes(ACL_PERMISSIONS.DATASET.WRITE);

  return canUserUploadFiles ? (
    <FadingTooltip title={tooltipText}>
      <IconButton color="primary" onChange={openUploadDialog} data-cy="datastore-upload-button" component="label">
        <input id="datastore-upload-input" type="file" accept={fileTypeFilter} hidden multiple />
        <Add />
      </IconButton>
    </FadingTooltip>
  ) : null;
};
